 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		57: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		57: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"vendors~ActionPlans~ClientDataUpload~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~Orgnizat~6e4aefea","1":"ActionPlans~ClientDataUpload~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~OrgnizationDashb~f514fcf5","2":"ActionPlans~ClientDataUpload~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~OrgnizationDashb~ebfe099c","3":"ActionPlans~DashboardSchoolAdmin~ImportTypes~Index~MetricsOverview~OrgnizationDashboard~OrgnizationR~3f20c953","4":"PreviewPoll~SchoolTeacherPoll~StudentPoll~TeacherPoll","5":"vendors~ResultsDashboard~Survey Builder~UnbecomeLoading~pdf","6":"vendors~ResultsDashboard~pdf","7":"Login~organization-page","8":"PreviewPoll","9":"ResultsDashboard","10":"Stylebook~SuperAdmin","11":"vendors~ResultsDashboard","12":"vendors~Stylebook~SurveyWizard","13":"ActionPlans","14":"ChangeEmail","15":"ClientDataUpload","16":"Closed","17":"DashboardSchoolAdmin","18":"ForgotPassword","19":"Home","20":"HomepageAbout","21":"HomepageBett","22":"HomepageJobs","23":"HomepageProduct","24":"HomepageQuestions","25":"IdentitySwitcher","26":"ImportTypes","27":"Index","28":"Login","29":"Logout","30":"MetricsOverview","31":"OrgnizationDashboard","32":"OrgnizationResultsIndex","33":"PrerequisitesError","34":"ResetPassword","35":"RespondentsClasses","36":"RespondentsGroups","37":"RespondentsIndex","38":"ResultsIndex","39":"SSOManagement","40":"SchoolTeacherPoll","41":"Self Assessment Survey","42":"Self Assessment Survey Results","43":"Short Terms","44":"Skola2030","45":"StudentDashboard","46":"StudentPoll","47":"Stylebook","48":"SuperAdmin","49":"Survey Builder","50":"SurveyCreate","51":"SurveyWizard","52":"TeacherDashboard","53":"TeacherPoll","54":"Terms","55":"UnbecomeLoading","56":"UsersAbout","58":"language-table","59":"matrix-headers-modal","60":"organization-admin-organizations","61":"organization-page","62":"pdf","63":"school-admin-add-tags","64":"school-admin-schools","65":"survey-results-public-urls","66":"tokenized","67":"translations-list","68":"urlexpired","69":"vendors~ClientDataUpload"}[chunkId]||chunkId) + "-" + {"0":"7bde8a64671daa40f724","1":"1e3744b7093b9df135c9","2":"fe3d4110c1d1626959b8","3":"27ad8a00af45df231118","4":"0a31b30b5657b6263801","5":"72b4ed2ff2a20528f99f","6":"5c76fc65dbe56d356ef1","7":"a0f685777a107388a877","8":"04d89588a8bc6a7989eb","9":"b47d9a6a67df0fafb9f4","10":"364ab3270f5592e6d684","11":"885452924c7ed364bc56","12":"1a1361dd7db9987a3c52","13":"1e7c9df1cc3e6cc73ce6","14":"0c6d6b6975ef3ff1b41f","15":"da1c73c3d6ce37826a89","16":"152532fba09eff4a2a41","17":"8a527a1a53b242b3fb79","18":"9e9f93f9ad7d5fae39ad","19":"8e718d0105d40283e15a","20":"e440dbcb038a7f9bdb1e","21":"142634eb2922786ebdf5","22":"e6bc7336f1ad0d3a1223","23":"034202d2cc399f7b4baf","24":"f144c36cd0e1a08106ad","25":"564adffe11d8a51a62e1","26":"b7ca057a8642119173a9","27":"33ca01852ad84d2e7e11","28":"16d036414bcd2b12f7a6","29":"2f2493a62fbb8a3fab04","30":"a96980b13b4f2329112b","31":"175ce939f34cc85d0dc2","32":"09e10f43fa039831bdac","33":"25a617612b7cb9a7dc8b","34":"f951dcc88856b62d051f","35":"57232db6774c23faa6de","36":"28c0a04f0edab179e1a2","37":"2c4d234754a0c659aa4e","38":"4d370d5a052888679c6e","39":"ec11dae3960c7d76ce88","40":"45cad31b5023da4608b1","41":"feb7949c8cc57c88bc30","42":"20e6a7749437866ccd11","43":"3b0667820a7bd2710198","44":"f9c6913c0d19b9005f73","45":"2fab2ba6c3e15af48575","46":"79d8800a2369710808e3","47":"317bc8998ab094e50ef1","48":"1156d683ba8ccc3500c1","49":"ccaecc67243aa5831d54","50":"020485db90997bcaf428","51":"b7c25823c09e752af654","52":"d7b0010252d2b5668bda","53":"3dbd13fd2315796f4122","54":"454170067af4ae99b40c","55":"3dde2207e3b284490667","56":"8b89923250d557319aab","58":"112471a9a07138153ca3","59":"60a3c603bc355935f97d","60":"61afd3dae18815b4fef3","61":"0fc6ad4e7601e5e813f2","62":"574b229589d72938293e","63":"c60c273614665e3ab47c","64":"47281fbc56fced2b3434","65":"1ce3c9d035c8904bb07c","66":"bf27c393b5c07c689ca1","67":"7cbbcf4edce574798ff2","68":"2efe2ec4077ca4e02b9c","69":"cdef2164b884711852f0","70":"603b30a2adc89b813c3d","71":"e96ed98a5db8c1041295","72":"e43d91ec5ed2a911ebc8","73":"727ab71e460b2b24c61d","74":"7439818631421bc5d9f5","75":"359b1203689d8ff90c01","76":"afcf0d511dac306ed0f6","77":"0c9ccdc50aa1efa4bd28","78":"3e4c7591958374efcf45","79":"d266ffc985999d77918d","80":"de4117c394dc73d18fd2","81":"de9952898e6e0358431e","82":"36ccb147d84e95e5b866","83":"38ee9c06acef903a52b3","84":"eb46501879cda4010734","85":"1cb78a359b9320bb4705","86":"c799f9e2c0927fab8df9","87":"c11830e7fdeeafbbddf2","88":"750eeabae0a4ab164561","89":"29abc2ea94ff4031930e","90":"693eccdc9571c8c8edbb","91":"d269084cc686f50f6556","92":"f53fec2f86ea6a112e90","93":"b7968aac1e27a2e60517","94":"feada5886abd21f1645b","95":"edadad53e19bd91665d0","96":"0ca3a575c7216cd20672","97":"18215fc30dac81668a0c","98":"c2d5bcd39bb60489ce6f","99":"46e88e7edaef005c2a7b","100":"e474b4ac101a4ae8a47c","101":"f03ca3da637030bd48b8","102":"3b71c22e47eda1ab0a4e","103":"6152300061ebc9f73f03","104":"d349abb8931dbbd1ac2a","105":"61139950b642bd4f324b","106":"ee6b152620ad49396e24","107":"cb978df92baa455aff5b","108":"e23b255d8ba7f7ea9bc6","109":"a791c1dd44cd6a83bdf8","110":"4a666c032530ca28f6f9","111":"f58264e8187b2a335faf","112":"73746bc6efe94b3fcb99","113":"b26ee70b9fb902eef58b","114":"f9442972254f8568bdda","115":"c8072e0067977583b020"}[chunkId] + "-chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"1":1,"2":1,"3":1,"4":1,"7":1,"9":1,"10":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"25":1,"26":1,"27":1,"28":1,"29":1,"31":1,"32":1,"34":1,"35":1,"36":1,"37":1,"38":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"48":1,"49":1,"51":1,"52":1,"54":1,"55":1,"56":1,"58":1,"59":1,"60":1,"61":1,"62":1,"63":1,"64":1,"67":1,"70":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "../material/css/build/main-stylesheet-" + {"0":"31d6cfe0d16ae931b73c","1":"fd0a26ce065213b8a815","2":"d9d785868676190bac6a","3":"763662e19a0728119d4c","4":"c80998c42fabe817e95e","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"6e96a9728c74815193a2","8":"31d6cfe0d16ae931b73c","9":"d0fe77cd23a1eeed5f70","10":"854321ff2f29017e8177","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"2424a9e3c065701d3035","14":"b305547c032f4a6c4ee1","15":"e828deea6972a8aa3412","16":"ae2608afbc401e508b59","17":"04bfbcea8944b8d2689e","18":"b305547c032f4a6c4ee1","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"4e295f58bcd887d692a5","26":"e42a12b3c8e7c419d6db","27":"b5ea0d0993b35460b3bd","28":"1804c101e609192ab5a1","29":"09c29e9ce1f11bde2d8b","30":"31d6cfe0d16ae931b73c","31":"4caeafcb441b6855831b","32":"bba4126e26461d1d573b","33":"31d6cfe0d16ae931b73c","34":"b305547c032f4a6c4ee1","35":"cf0c2ab80e649298ea63","36":"e1c26d8fd95d12558741","37":"844a47eaf875d5fa85b8","38":"bba4126e26461d1d573b","39":"31d6cfe0d16ae931b73c","40":"31d6cfe0d16ae931b73c","41":"f4865760421016748e19","42":"fc748f1bd50e1a4de611","43":"b31d44ecf0e6705d567d","44":"c9e198da19cc9d653930","45":"d4d5c8811bed3de477ee","46":"31d6cfe0d16ae931b73c","47":"9019b1257f975bb0a4a9","48":"b3e735eae76fb963fdc5","49":"817c28ad709ed70e555c","50":"31d6cfe0d16ae931b73c","51":"f7770c4ff3f70333d890","52":"baaf7c42095917a70075","53":"31d6cfe0d16ae931b73c","54":"fe3e623dd55d95f2c4a5","55":"6a3623633c16bd4639ac","56":"c9e198da19cc9d653930","58":"fb34be6303bc3e3de371","59":"d934cef0d053066c1fb5","60":"836a7419d55a9e73a8a8","61":"c793adae31ea25cdbbf8","62":"70e0de5d794ccec5cef8","63":"5001f28753851ae5752f","64":"63c142b007e5002a6aef","65":"31d6cfe0d16ae931b73c","66":"31d6cfe0d16ae931b73c","67":"3a3849ee951af21d37a5","68":"31d6cfe0d16ae931b73c","69":"31d6cfe0d16ae931b73c","70":"11196146f234db879a4a","71":"31d6cfe0d16ae931b73c","72":"31d6cfe0d16ae931b73c","73":"31d6cfe0d16ae931b73c","74":"31d6cfe0d16ae931b73c","75":"31d6cfe0d16ae931b73c","76":"31d6cfe0d16ae931b73c","77":"31d6cfe0d16ae931b73c","78":"31d6cfe0d16ae931b73c","79":"31d6cfe0d16ae931b73c","80":"31d6cfe0d16ae931b73c","81":"31d6cfe0d16ae931b73c","82":"31d6cfe0d16ae931b73c","83":"31d6cfe0d16ae931b73c","84":"31d6cfe0d16ae931b73c","85":"31d6cfe0d16ae931b73c","86":"31d6cfe0d16ae931b73c","87":"31d6cfe0d16ae931b73c","88":"31d6cfe0d16ae931b73c","89":"31d6cfe0d16ae931b73c","90":"31d6cfe0d16ae931b73c","91":"31d6cfe0d16ae931b73c","92":"31d6cfe0d16ae931b73c","93":"31d6cfe0d16ae931b73c","94":"31d6cfe0d16ae931b73c","95":"31d6cfe0d16ae931b73c","96":"31d6cfe0d16ae931b73c","97":"31d6cfe0d16ae931b73c","98":"31d6cfe0d16ae931b73c","99":"31d6cfe0d16ae931b73c","100":"31d6cfe0d16ae931b73c","101":"31d6cfe0d16ae931b73c","102":"31d6cfe0d16ae931b73c","103":"31d6cfe0d16ae931b73c","104":"31d6cfe0d16ae931b73c","105":"31d6cfe0d16ae931b73c","106":"31d6cfe0d16ae931b73c","107":"31d6cfe0d16ae931b73c","108":"31d6cfe0d16ae931b73c","109":"31d6cfe0d16ae931b73c","110":"31d6cfe0d16ae931b73c","111":"31d6cfe0d16ae931b73c","112":"31d6cfe0d16ae931b73c","113":"31d6cfe0d16ae931b73c","114":"31d6cfe0d16ae931b73c","115":"31d6cfe0d16ae931b73c"}[chunkId] + "-chunk.css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/vue/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 282);
